import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Channel } from "../channel/channel.entity";
import { upsertChannel } from "../channel/channelSlice";
import type { ChatMessage } from "../chatMessage/chatMessage.entity";
import {
  updateChatMessageList,
  upsertChatMessage,
  upsertChatMessageList,
} from "../chatMessage/chatMessageSlice";
import { getMessagePrimaryKey } from "../chatMessage/getMessagePrimaryKey";
import { createThunkName } from "../redux/createThunkNamespace";
import type { ThunkBase } from "../redux/types";
import type { User } from "../user/user.entity";
import { upsertUserList } from "../user/userSlice";

type ActiveChannelNewMessageEventThunkPayload = {
  message: Record<string, ChatMessage>;
};
export const activeChannelNewMessageEventThunk = createAsyncThunk<
  void,
  ActiveChannelNewMessageEventThunkPayload,
  ThunkBase
>(
  createThunkName("activeChannelNewMessageEventThunk"),
  async ({ message }, { dispatch }) => {
    dispatch(upsertChatMessageList(message));
  },
);

type ReadMessageEventThunkPayload = {
  chatMessages: ChatMessage[];
};

export const readMessageEventThunk = createAsyncThunk(
  createThunkName("readMessageEventThunk"),
  async ({ chatMessages }: ReadMessageEventThunkPayload, { dispatch }) => {
    dispatch(
      updateChatMessageList(
        chatMessages.map((message) => ({
          id: getMessagePrimaryKey({
            message: { id: message.id, channelId: message.channel_id },
          }),
          changes: {
            seen: message.seen,
          },
        })),
      ),
    );
  },
);

type RenewChannelEventThunkPayload = {
  channel: Channel;
  users: Record<string, User>;
  lastChatMessage: ChatMessage | undefined;
};
export const renewChannelEventThunk = createAsyncThunk<
  void,
  RenewChannelEventThunkPayload,
  ThunkBase
>(
  createThunkName("renewChannelEventThunk"),
  async ({ channel, users, lastChatMessage }, { dispatch }) => {
    dispatch(upsertChannel(channel));
    dispatch(upsertUserList(users));
    if (lastChatMessage) {
      dispatch(upsertChatMessage(lastChatMessage));
    }
  },
);
